/**
 * Shared value utility functions for Static Web Generator
 * Consolidates duplicated hasValue, getValue, getStateValue functions
 */

/**
 * Check if a value is non-empty (not null, undefined, empty string, or empty array)
 */
export const hasValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string" && value.trim() === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
};

/**
 * Get trimmed value or undefined if empty
 */
export const getValue = (value: any): any => {
  if (!hasValue(value)) return undefined;
  if (typeof value === "string") return value.trim();
  return value;
};

/**
 * Get state value - preserves empty strings from preview data
 * Returns undefined only for null/undefined, keeps empty strings
 */
export const getStateValue = (value: any): any => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "string") return value.trim();
  return value;
};

/**
 * Filter array items, removing null/undefined/empty strings
 */
export const filterEmptyItems = (items: any[]): any[] => {
  return items.filter((item) => {
    if (item === null || item === undefined) return false;
    if (typeof item === "string" && item.trim() === "") return false;
    return true;
  });
};
